require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-paris-motor-show-2018-week-1-round-up.json") })
        }
      }, "path---news-paris-motor-show-2018-week-1-round-up");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-paris-motor-show-2018-week-1-round-up!./.cache/json/news-paris-motor-show-2018-week-1-round-up.json
// module id = 1431
// module chunks = 231608221292675